import { useEffect, useState } from 'react'
import TarjetScort from '../hooks/TarjetScort'
import imagenBanner1 from '../img/bannerPrincipal.png'
import imagenBanner2 from '../img/bannerAngels.png'
import Filtros from './Filtros'
import Contactos from './Contactos'
import { AuthServices } from '../util/authServices'

const Principal = ({ toast, openMenuFilter, setOpenMenuFilter, setCargando }) => {

    const [scortObjectList, setScortObjectList] = useState([])
    const [controlLoadTarjetScort, setControlLoadTarjetScort] = useState(true)

    useEffect(() => {
        obtieneListaScorts()
    }, [])

    const obtieneListaScorts = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "origen": "landing",
            }
            const response = await authServices.requestPost(body, 1);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setScortObjectList(objeto)
                setControlLoadTarjetScort(false);
                setTimeout(() => {
                    setControlLoadTarjetScort(true);
                }, 150)
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    return (
        <>
            <div className='div-banner-imagen'>
                <img src={imagenBanner1} alt='Banner-Scorts' className='img-banner-principal'></img>
            </div>
            <div className='div-menu-active'>
                <div className={openMenuFilter ? 'div-menu-filters' : 'div-menu-filters-off'} >
                    <Filtros toast={toast} setOpenMenuFilter={setOpenMenuFilter} setScortObjectList={setScortObjectList}
                        setControlLoadTarjetScort={setControlLoadTarjetScort} setCargando={setCargando} />
                </div>
            </div>
            <div className='div-banner-imagen-angels-padre'>
                <div className='div-banner-imagen-angels-hijo'>
                    <img src={imagenBanner2} alt='Banner-Scorts' className='img-banner-principal'></img>
                </div>
            </div>

            <div className='div-texto-informativo' >
                <p className='texto-informativo'>
                    EL CATÁLOGO MÁS COMPLETO DE ESCORTS,<br />
                    CALL GIRLS Y DAMAS DE COMPAÑÍA <br />
                    EN BOGOTÁ<br />
                </p>
            </div>
            <div className="row m-0">
                <div className="col-12 col-sm-3 col-md-4 col-lg-4 "></div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4 ">
                    <div className='div-contactos-principal'>
                        <Contactos />
                    </div>
                </div>
                <div className="col-12 col-sm-3 col-md-4 col-lg-4 "></div>
            </div>
            <div className="div-content-principal">
                <div className="row m-0">
                    {
                        controlLoadTarjetScort ?
                            scortObjectList?.map((scortObjet, i) => {
                                return (
                                    <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-4 p-0 mt-4 " >
                                        <TarjetScort scortObjet={scortObjet} preView='landingScort' />
                                    </div>
                                )
                            })
                            :
                            <></>
                    }
                </div>
            </div>
            <div className="mb-5" ></div>
        </>
    )
}

export default Principal